<template>
  <div>
    <div class="container-fluid featured-page-image">
      <div class="feature-header-page">
        <h1>Services</h1>
      </div>
    </div>
    <div class="container">
      <div class="intro">
        <h2>Our Services</h2>
        <hr>
      </div>
      <div class="internal-content">
        <h2>New Roof Installations and Roofing Maintenance</h2>
        <p>Is your damaged roof in need of urgent repair? For a quick response and reliable team, look no further than
          KD Roofing.</p>
        <p>As well experienced roofers, we bring a high level of expertise, skill and knowledge to each job, whether
          installing a new slate roof or repairing a chimney.</p>
        <p>Through the years we have covered a range of roofing and building projects, including Velux window
          installations and roof/loft conversions, so if you’re looking to expand your home,
          <router-link to="/contact/">give us a call</router-link>
          to discuss your options.
        </p>
        <h2>Our full range of roofing and building services include:</h2>
        <ul>
          <li>New roof installations</li>
          <li>All roof repairs</li>
          <li>Pitched roofs</li>
          <li>Flat roofs</li>
          <li>Slate roofs</li>
          <li>Loft conversions</li>
          <li>All lead work</li>
          <li>Building maintenance</li>
          <li>Fascias and guttering</li>
          <li>House extensions</li>
          <li>Chimney repairs</li>
          <li>Carpentry works</li>
        </ul>
        <p>For more information about any of our services or to arrange a free estimate, don’t hesitate to <router-link to="/contact/">call us</router-link> today.</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Services'
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Services.vue